import { Component, OnInit } from '@angular/core';
import { Noticia } from 'src/app/models/noticia.model';
import { NoticiasService } from 'src/app/services/noticias.service';

@Component({
  selector: 'app-geral',
  templateUrl: './geral.component.html',
  styleUrls: ['./geral.component.css']
})
export class GeralComponent implements OnInit {

  public noticias : Noticia[]
  
  constructor(ns: NoticiasService)
  {
      ns.getNoticiasGeral()
      .subscribe((dados: Noticia[]) => this.noticias = dados);
  }

  ngOnInit(): void {
  }

}
